import React from 'react';
import { InlineBanner } from 'src/components/inline-banner';
import { InlineBannerProps } from 'src/components/inline-banner/inline-banner';
import { css } from 'styled-components';

export const PaymentBanner = (props: InlineBannerProps): JSX.Element => (
  <InlineBanner border={false} padding='8px 16px' contentStyles={contentStyles} {...props} />
);

// Alert Style Overrides
const alertBoldTextStyles = css`
  font-weight: 600;
  margin-right: 6px;
`;

const alertTextStyles = css`
  font-weight: 400;
  display: inline;
`;

const contentStyles = css`
  font-feature-settings: 'calt' off;
  letter-spacing: 0.065px;
  font-size: 13px;
  strong {
    ${alertBoldTextStyles}
  }
  p {
    ${alertTextStyles}
  }
`;
